<template>
  <div class="predelivery">
    <Feedback v-if="!feedbackGiven" />
    <v-btn
      color="#6dbe45"
      class="btns"
      style="color: #ffffff"
      @click="navigateCartPage()"
      >Back to cart</v-btn
    >
    <h3 style="font-weight: bold; color: white; margin-top: 15px">
      Container Delivery Details
    </h3>
    <DeliveryInstructions />
    <br />
    <Timeline />
    <br />
    <OtherDetails />

    <!-- Scroll to top button -->
    <transition name="slide-fade">
      <div
        id="pagetop"
        class="fixed right-0 bottom-0"
        v-show="scY > 2300"
        @click="scrollToTop()"
      >
        <v-btn fab small color="black" @click="scrollToTop()" class="gotoTop">
          <v-icon color="yellow">mdi-arrow-up</v-icon>
        </v-btn>
      </div>
    </transition>
    <br />
    <!--Loder starts -->
    <v-overlay :value="loader">
      <v-btn color="#6dbe45" large style="width: 130px">
        <span class="spinner-border spinner-border-sm"></span>
        Loading...
      </v-btn>
    </v-overlay>
    <!--Loder ends -->
    <v-btn
      class="btns cancel_btn"
      medium
      color="#00587d"
      style="color: #ffffff"
      @click="navigateCartPage()"
      >Cancel</v-btn
    >
    <v-btn
      @click="checkout"
      color="#6dbe45"
      class="btns checkout_btn"
      style="color: #ffffff"
      medium
      v-if="getProductsSize() >= 1"
      :disabled="!ValidateUserInputs()"
      >Checkout</v-btn
    >
  </div>
</template>

<script>
import Client from "shopify-buy";
import { mapGetters } from "vuex";
import Feedback from "../FixedComponents/Feedback.vue";
import _ from "lodash";
import * as country_based_data from "@/JS/CountryBasedData.js";
import * as types from "@/store/types";
import DeliveryInstructions from "./pages/DeliveryInstructions";
import Timeline from "./pages/Timeline";
import OtherDetails from "./pages/OtherDetails";

export default {
  name: "PredeliveryForm",
  components: {
    Feedback,
    DeliveryInstructions,
    Timeline,
    OtherDetails,
  },
  data() {
    return {
      containerList: [],
      client: null,
      checkoutId: "",
      webUrl: "",
      cscQuantity: 0,
      cscSurveyId: "",
      loader: false,
      scTimer: 0,
      scY: 0,
    };
  },
  computed: {
    ...mapGetters({
      feedbackGiven: types.FEEDBACKGIVEN,
      COUNTRY_CODE: types.COUNTRYCODE,
      cart: types.CART_LIST,
      terms_conditions: types.TERMSCHECKBOX,
      predelivery: types.PREDELIVERYANSWERS,
      doorDirection: types.DELIVERY_DOORDIRECTION,
      deliveryName: types.DELIVERY_NAME,
      deliverySpace: types.DELIVERY_SPACE,
      deliveryPhone: types.DELIVERY_PHONE,
      deliveryRustAcknowledge: types.DELIVERY_RUSTACKNOWLEDGE,
      deliverySurface: types.DELIVERY_SURFACETYPE,
    }),
  },
  mounted() {
    //If the terms and conditions is not checked or cart is empty, go to the cart page.
    if (this.cart.length === 0 || !this.terms_conditions)
      this.$router.push("/purchase/container/cart");

    window.scrollTo(0, 0);
    this.containerList = this.cart;
    this.initializeShopify(); //Initialize Shopify
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 200);
    },
    scrollToTop() {
      document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    },
    initializeShopify() {
      /*Initialize shopify domain and storefront token Id based on the country code which is 
        dynamically changed based on the domain names */
      var shopifyDomain, storefrontTokenID;
      if (this.COUNTRY_CODE === "US") {
        shopifyDomain = [country_based_data.USAShopifyDomain];
        storefrontTokenID = [country_based_data.USAStorefrontAccessToken];
      } else if (this.COUNTRY_CODE === "CA") {
        shopifyDomain = [country_based_data.CanadaShopifyDomain];
        storefrontTokenID = [country_based_data.CanadaStorefrontAccessToken];
      }

      this.client = new Client.buildClient({
        domain: shopifyDomain,
        storefrontAccessToken: storefrontTokenID,
      });

      // create Shopify checkout
      this.client.checkout.create().then((checkout) => {
        this.checkoutId = checkout.id;
        this.webUrl = checkout.webUrl;
      });
    },
    addlineitems() {
      //add line items into Shopify checkout using variant ID
      const lineItemsToAdd = [];
      var i;
      for (i = 0; i < this.containerList.length; i++) {
        var ID = this.containerList[i]["id"];
        var QUANTITY = this.containerList[i]["quantity"];
        var customAttributes = [
          {
            key: "Delivery",
            value: this.containerList[i]["customAttributes"]["Delivery"],
          },
          {
            key: "CSCSurveyRequired",
            value: this.containerList[i]["customAttributes"][
              "CSCSurveyRequired"
            ].toString(),
          },
        ];
        if ("CSCSurvey" in this.containerList[i]) {
          this.cscQuantity += QUANTITY;
          this.cscSurveyId = this.containerList[i]["CSCSurvey"]["id"];
        }
        var lineItem = {
          variantId: ID,
          quantity: QUANTITY,
          customAttributes: customAttributes,
        };
        lineItemsToAdd.push(lineItem);
      }
      //add csc survey to shopify checkout
      if (this.cscQuantity > 0) {
        const CSCID = this.cscSurveyId;
        const CSCQUANTITY = this.cscQuantity;
        const CSClineItem = { variantId: CSCID, quantity: CSCQUANTITY };
        lineItemsToAdd.push(CSClineItem);
      }
      this.client.checkout
        .addLineItems(this.checkoutId, lineItemsToAdd)
        .then(() => {
          this.addSurevyCustomAttributes();
        })
        .catch((err) => {
          this.loader = false;
          console.log(err);
        });
    },
    addSurevyCustomAttributes() {
      //Add predelivery survey questions
      var surveyAttributes = [];

      const predeliveryData = [
        {
          question_name: "DOOR_DIRECTION",
          answer: this.predelivery.doordirection,
        },
        {
          question_name: "DELIVERY_SPACE_ACKNOWLEDGE",
          answer: this.predelivery.deliveryspace,
        },
        {
          question_name: "RUST_ACKNOWLEDGE",
          answer: this.predelivery.rustacknowledge,
        },
        {
          question_name: "NON_ACCEPTABLE_DATES",
          answer: this.predelivery.nonacceptabledates,
        },
        {
          question_name: "ADDITIONAL_COMMENTS",
          answer: this.predelivery.deliveryinstructions,
        },
        {
          question_name: "ORDER_CONTACT_NAME",
          answer: this.predelivery.deliveryname,
        },
        {
          question_name: "ORDER_CONTACT_PHONENUMBER",
          answer: this.predelivery.deliveryphone,
        },
        {
          question_name: "DELIVERY_SURFACE",
          answer: this.predelivery.deliverysurfacetype,
        },
      ];

      surveyAttributes.push({
        key: "PreDeliverySurvey",
        value: JSON.stringify(predeliveryData),
      });

      const input = { customAttributes: surveyAttributes };

      this.client.checkout
        .updateAttributes(this.checkoutId, input)
        .then(() => {
          this.loader = false;
          window.location.href = this.webUrl;
        })
        .catch((err) => {
          this.loader = false;
          console.log(err);
        });
    },
    getProductsSize() {
      return this.containerList.length;
    },
    checkout: _.throttle(function () {
      //Disable checkout button once clicked for 3seconds
      this.loader = true;
      this.addlineitems();
    }, 3000),
    ValidateUserInputs() {
      return (
        this.deliveryName &&
        this.deliveryPhone &&
        this.doorDirection &&
        this.deliverySpace &&
        this.deliveryRustAcknowledge &&
        this.deliverySurface
      );
    },
    navigateCartPage() {
      this.$router.push("/purchase/container/cart");
    },
  },
};
</script>

<style scoped>
.btns {
  height: 50px;
  color: #00587d;
  text-decoration: none;
  text-transform: unset !important;
  border-radius: 20px;
  font-weight: 900;
  margin: 10px;
}

.checkout_btn {
  box-shadow: 1px 1px 1px 1px #ffffff;
}
.cancel_btn {
  box-shadow: 1px 1px 1px 1px #6dbe45;
}

.predelivery {
  margin: auto;
  width: 80%;
  padding: 10px;
  margin-bottom: 50px;
  color: #ffffff;
}

@media only screen and (max-width: 480px) {
  .predelivery {
    width: 100%;
  }
}

.gotoTop {
  float: right;
  cursor: pointer;
  right: 30px;
  bottom: 200px;
  position: absolute;
}

.slide-fade-enter-active {
  transition: all 1s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(30px);
  opacity: 0;
}
</style>
